import { FC } from 'react'
import { News } from '@/root/shared-types'
import { Notifications } from '@/root/modules/tuuleliinid'

interface NewsSectionProps {
  news: News[]
  headingValue?: string
}

export const NewsSection: FC<NewsSectionProps> = ({ news, headingValue }) => (
  <div className="bg-white">
    <Notifications news={news} headingValue={headingValue} />
  </div>
)
